<template>
  <div class="flex items-center h-16 border-solid p-3 sticky top-0 bg-white z-50"
       :class="selectedExamplesCount ? 'border border-gray rounded shadow-card animate-fade-in' : 'border-0 border-b border-soft'"
  >
      <checkbox v-if="showCheckbox"
                :is-checked="!!selectedExamplesCount"
                :class="[
                  { 'mt-px': !selectedExamplesCount, 'cursor-not-allowed': answerExamplesCount === 0 },
                  answerExamplesCount === 1 ? 'cursor-not-allowed' : 'cursor-pointer'
                ]"
                ref="checkbox"
                id="intent-examples-header-checkbox"
                :disabled="answerExamplesCount <= 1"
                @update:isChecked="onChecked"
      />

    <intent-examples-header-bulk v-if="mode === EXAMPLE_EDITOR_MODE.BULK"
                                 :checkboxId="checkboxRef()"
                                 :selected-examples-count="selectedExamplesCount"
                                 @update-mode="updateMode"
    />

    <intent-examples-header-bulk-delete v-else-if="mode === EXAMPLE_EDITOR_MODE.BULK_DELETE"
                                        :selected-examples-count="selectedExamplesCount"
                                        @update-mode="updateMode"
                                        @delete-examples="$emit('delete-examples')"
    />

    <intent-examples-header-bulk-move v-else-if="mode === EXAMPLE_EDITOR_MODE.BULK_MOVE"
                                      :selected-examples-count="selectedExamplesCount"
                                      :is-bulk-move-ready="isBulkMoveReady"
                                      @update-mode="updateMode"
                                      @move-examples="$emit('move-examples')"
    />

    <intent-examples-header-default v-else
                                    :examples-count="answerExamplesCount"
                                    @update-mode="updateMode"
    />
  </div>
</template>

<script>
import Checkbox from '@/components/preview/Checkbox'
import { EXAMPLE_EDITOR_MODE } from '@/store/constants'
import IntentExamplesHeaderBulk from './IntentExamplesHeaderBulk'
import IntentExamplesHeaderBulkDelete from './IntentExamplesHeaderBulkDelete'
import IntentExamplesHeaderBulkMove from './IntentExamplesHeaderBulkMove'
import IntentExamplesHeaderDefault from './IntentExamplesHeaderDefault'
import answerModule from '@/store/modules/answer.module'

export default {
  name: 'IntentExamplesHeader',
  components: {
    Checkbox,
    IntentExamplesHeaderBulk,
    IntentExamplesHeaderBulkDelete,
    IntentExamplesHeaderBulkMove,
    IntentExamplesHeaderDefault
  },
  props: {
    intentExamples: {
      type: Array
    },
    selectedExamplesCount: {
      type: Number
    },
    isBulkMoveReady: {
      type: Boolean,
      default: false
    },
    mode: {
      type: Number,
      required: true
    }
  },

  watch: {
    selectedExamplesCount: {
      immediate: true,
      handler: function (selectedExamplesCount) {
        const examplesTotal = this.answerExamplesCount
        if (selectedExamplesCount && selectedExamplesCount < examplesTotal) {
          this.displayCheckboxIndeterminate(true)
        } else if (selectedExamplesCount === examplesTotal) {
          this.displayCheckboxIndeterminate(null)
        } else if (!selectedExamplesCount) {
          this.displayCheckboxIndeterminate(false)
        }
      }
    }
  },

  data() {
    return {
      EXAMPLE_EDITOR_MODE
    }
  },

  computed: {
    answerExamplesCount: answerModule.getAnswerExamplesCount,

    showCheckbox() {
      return ![EXAMPLE_EDITOR_MODE.BULK_DELETE, EXAMPLE_EDITOR_MODE.BULK_MOVE].includes(this.mode)
    }
  },

  methods: {
    displayCheckboxIndeterminate(isDisplayed) {
      this.$nextTick(() => {
        this.$refs.checkbox?.displayIndeterminate(isDisplayed)
      })
    },

    checkboxRef() {
      return this.$refs.checkbox?.id
    },

    onChecked() {
      if (this.selectedExamplesCount) {
        this.$emit('deselect-all')
        return
      }

      this.$emit('select-all')
    },

    updateMode(mode) {
      this.$emit('update-mode', mode)
    }
  }
}
</script>
